const scrollPadding = {
  name: "scroll-padding",
  path: "scroll-padding",
  title: "scroll-padding",
  description: "Utilities for controlling the CSS scroll-padding properties.",
  value: {
    "scroll-padding": {
      "scroll-p-<number>": "scroll-padding: calc(var(--1) * <number>);",
      "-scroll-p-<number>": "scroll-padding: calc(var(--1) * -<number>);",
      "scroll-p-[<value>]": "scroll-padding: <value>;",
      "scroll-px-<number>": "scroll-padding-inline: calc(var(--1) * <number>);",
      "-scroll-px-<number>": "scroll-padding-inline: calc(var(--1) * -<number>);",
      "scroll-px-[<value>]": "scroll-padding-inline: <value>;",
      "scroll-py-<number>": "scroll-padding-block: calc(var(--1) * <number>);",
      "-scroll-py-<number>": "scroll-padding-block: calc(var(--1) * -<number>);",
      "scroll-py-[<value>]": "scroll-padding-block: <value>;",
      "scroll-pt-<number>": "scroll-padding-top: calc(var(--1) * <number>);",
      "-scroll-pt-<number>": "scroll-padding-top: calc(var(--1) * -<number>);",
      "scroll-pt-[<value>]": "scroll-padding-top: <value>;",
      "scroll-pr-<number>": "scroll-padding-right: calc(var(--1) * <number>);",
      "-scroll-pr-<number>": "scroll-padding-right: calc(var(--1) * -<number>);",
      "scroll-pr-[<value>]": "scroll-padding-right: <value>;",
      "scroll-pb-<number>": "scroll-padding-bottom: calc(var(--1) * <number>);",
      "-scroll-pb-<number>": "scroll-padding-bottom: calc(var(--1) * -<number>);",
      "scroll-pb-[<value>]": "scroll-padding-bottom: <value>;",
      "scroll-pl-<number>": "scroll-padding-left: calc(var(--1) * <number>);",
      "-scroll-pl-<number>": "scroll-padding-left: calc(var(--1) * -<number>);",
      "scroll-pl-[<value>]": "scroll-padding-left: <value>;"
    }
  },
  exampleData: [
    {
      title: "scroll-p-4, scroll-px-8, scroll-pt-2",
      description: "Set scroll margin on elements for scroll positioning:",
      example: {
        code: `<div class="scroll-p-4 ...">scroll-padding: 1rem</div>
<div class="scroll-px-8 ...">scroll-padding-inline: 2rem</div>
<div class="scroll-pt-2 ...">scroll-padding-top: 0.5rem</div>`
      }
    }
  ],
  htmlData: [
    {
      title: "Scroll margin",
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">scroll-p-*</code> utilities to control scroll-padding properties of an element.
      </p>
      <div class="flex w-full snap-x gap-12 overflow-x-auto py-14 *:whitespace-nowrap *:border *:border-color-gray-200">
        <div class="scroll-p-4 bg-blue-100 rounded p-2">scroll-p-4</div>
        <div class="scroll-px-8 bg-green-100 rounded p-2">scroll-px-8</div>
        <div class="scroll-pt-2 bg-yellow-100 rounded p-2">scroll-pt-2</div>
        <div class="scroll-p-4 bg-blue-100 rounded p-2">scroll-p-4</div>
        <div class="scroll-px-8 bg-green-100 rounded p-2">scroll-px-8</div>
        <div class="scroll-pt-2 bg-yellow-100 rounded p-2">scroll-pt-2</div>
        <div class="scroll-p-4 bg-blue-100 rounded p-2">scroll-p-4</div>
        <div class="scroll-px-8 bg-green-100 rounded p-2">scroll-px-8</div>
        <div class="scroll-pt-2 bg-yellow-100 rounded p-2">scroll-pt-2</div>
      </div>
      `
    }
  ]
};

export default scrollPadding;
      <div class="flex w-full snap-x gap-12 overflow-x-auto py-14 *:whitespace-nowrap *:border *:border-color-gray-200">
        <div class="scroll-p-4 bg-blue-100 rounded p-2">scroll-p-4</div>
        <div class="scroll-px-8 bg-green-100 rounded p-2">scroll-px-8</div>
        <div class="scroll-pt-2 bg-yellow-100 rounded p-2">scroll-pt-2</div>
      </div>